<template>
 
  <div id="Vue"  >
 
  <el-row >
  <el-col :span="22" :offset="1"> 
   
  <el-row  style=" padding:20px;margin-top:10px;background: #fff;  " justify="left"  >
 
  <el-descriptions class="margin-top" title="" :column="1" border>
 
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-user"></i>
        公司名称： 
      </template>
      {{company_name}}
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-office-building"></i>
         地址：
      </template>
       {{company_address}}
    </el-descriptions-item>  
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-message"></i>
         邮箱：
      </template>
       {{company_email}}
    </el-descriptions-item> 
  </el-descriptions>
  </el-row>
 
  <el-row style=" padding:20px;margin-top:10px;background: #fff;  " justify="left"  >
  <div id="main" style="width: 90%;height:300px;"></div>
  </el-row>
  <el-row style=" padding:20px;margin-top:10px;background: #fff;  " justify="left"  > 
  <div style="font-size:16px; font-weight:bold">HS编码分类占比 </div>
  <div id="hscode" style="width: 90%;height:300px;"></div>
  </el-row>
  <el-row style=" padding:20px;margin-top:10px;background: #fff;  " justify="left"  >
 
  
  <el-table id="dataList" v-loading="loading"
    :data="tableData" 
	border 
    style="width: 100%"
	
     >
    <el-table-column
      prop="id"
      label="id" 
	  v-if="id==-2" 
      width="0%">
    </el-table-column>
    <el-table-column
      fixed
      prop="dt"
      label="日期"
      min-width="10%">
    </el-table-column>
    <el-table-column
      prop="hs_code"
      label="HS编码"
      min-width="10%">
    </el-table-column>
    <el-table-column
      prop="product_desc"
      label="货物描述"
      min-width="20%">
	  	  <template slot-scope="scope">
                            <div v-html="scope.row.product_desc"></div>
          </template> 
    </el-table-column>
    <el-table-column
      prop="consignee_name"
      label="采购商"
      min-width="20%">
	  	  <template slot-scope="scope">
                            <div v-html="scope.row.consignee_name"></div>
          </template> 
    </el-table-column>	
    <el-table-column
      prop="shipper_name"
      label="供应商"
      min-width="20%">
	  	  <template slot-scope="scope">
                            <div v-html="scope.row.shipper_name"></div>
          </template> 
    </el-table-column>		
    <el-table-column
      prop="prod_weight"
      label="重量(kg)"
      min-width="10%">
    </el-table-column>
    
  </el-table>
  <div style="margin-top:10px; display: flex; align-items:right; justify-content: flex-end;  ">
 
  <el-pagination @current-change="handlePageChange" :current-page="page" :page-size="10" layout="total, prev, pager, next, jumper" :total="total">
				</el-pagination>
 				
  </div>
  </el-row>  
  </el-col>
  </el-row>
</div>
</template>
<style>
  .el-header {
    background-color: #B3C0D1;
    color: #333;
    line-height: 60px;
  }
  
  .el-aside {
    color: #333;
  }
</style>

<script>
  import * as echarts from 'echarts';
export default {
 
        data () {
            return {
	    	componentName: 'info',
		    userInfo: {},
			loading: false,
			login_state : false,
			id: 0,
			page: 1,
			size:10,
		    total: 0,
			shipInfo: {},
			hsInfo: {},
			buttonQuery: 1,
			status:true,
			region: '',
			company_name:'',
			company_type:'',
			company_email:'',
			company_address: '',
			tableHeight: '600px',
			dialogVisible: false,
			form:{ region:'', 
			       keywords:'',
				   type: '', 
				   
				   bl_number: '',
				   dt: '',
				   shipper_name: '',
				   shipper_address:'',
				   consignee_name:'',
				   consignee_address: '',
				   notify_name:'',
				   Vessel_name:'',
				   loading_port: '',
				   unloading_port: '',
				   hs_code: '',
				   product_desc: '',
				   weight: 0,
				   CBM:0,
				   pkg_number:'',
				   qty_number:'',
				   pkg_unit:'',
				   qty_unit:'',
				   fob_unit:'',
				   fob_currency:'',
				   fob_total:'',
				   
				 },
			tableData:[],
			}  
        },
        methods: {
		    handleDetail(index, row){
			   localStorage.setItem('billId', row.id);
			    
			   this.dialogVisible = true;
			   
			},
		    handleSelect(key, keyPath) {
	           if (key == 1)
			      this.back();
				  
	           if (key == 2)
			      this.login();				  
			},
			handlePageChange(val) {
				this.page = val;
				this.buttonQuery = 0;
				//保存到localStorage
				localStorage.setItem('adPage', this.page)
				localStorage.setItem('adFilterForm', JSON.stringify(this.filterForm));
				this.getInfo()
			},		
		    onSubmit(){
				if (this.form.keywords == ''){
				    this.$message({
							message: '关键词不能为空 ! ',
							type: 'warning'
							});
				    return;
				}			    
			
			    this.page = 1;
				this.id = 0;
				this.buttonQuery = 1;
				this.getInfo();
				},
			getInfo( ){ 
			    let that = this;
				that.loading = true;
				var myChart = echarts.init(document.getElementById('main')); 
				var hsChart = echarts.init(document.getElementById('hscode')); 
				myChart.showLoading();
				hsChart.showLoading();
				that.tableHeight = "800px";
				  $.ajax({
					  type: "POST",
					  data:  {user_id: 0,  
							  keywords: that.company_name,
							  type : that.company_type,
							  page: that.page,
							  size: 10,
							  
							  },
					  url:  "https://www.myferp.com/admin/user/groupStat",  //"https://www.myferp.com/admin/user/companyReport",
					  dataType: "json",  //返回类型为 json
					  beforeSend: function (request) {
						request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
						},   
					  error: function(XMLHttpRequest, textStatus, errorThrown) { 
						  that.loading = false;
						  that.$message({
							message: data,
							type: 'error'
							});
								return false;
							},             
					  success: function (data) {
						
						  hsChart.hideLoading();
						  myChart.hideLoading();
						  
						  that.tableData = data.data.info.data ; 
						  that.page = parseInt(data.data.info.currentPage )  ;
						  that.total = data.data.info.count;
						  that.hsInfo = data.data.hsInfo;
						  that.shipInfo = data.data.shipInfo; 
						  console.log('hsInfo:' + JSON.stringify(that.hsInfo));
						 
						 if (that.page == 1){
							  var x = [];
							  var ser = [];
							  for (var i = 0 ; i < that.shipInfo.length; i++){
								   x.push(that.shipInfo[i].m);
								   ser.push(that.shipInfo[i].cnt);
							  }
							  
								// 指定图表的配置项和数据
								var option = {
									title: {
										text: '最近货运记录'
									},
									tooltip: {},
									legend: {
										data:['次数']
									},
									xAxis: {
										data: x  //["衬衫","羊毛衫","雪纺衫","裤子","高跟鞋","袜子"]
									},
									yAxis: {},
									series: [{
										name: '次数',
										type: 'line',
										data: ser //[5, 20, 36, 10, 10, 20]
									}]
								};

								// 使用刚指定的配置项和数据显示图表。
								myChart.setOption(option);


							  var x1 = []; 
							  var hsInfo = {};
							  for (var j = 0 ; j < that.hsInfo.length; j++){
								   hsInfo = {};
								   hsInfo.value = that.hsInfo[j].cnt ;
								   hsInfo.name = that.hsInfo[j].hs_code + '  ' + parseFloat(that.hsInfo[j].cnt/that.total*100).toFixed(2) + '%' ;
								   x1.push(hsInfo); 
							  }
							  
								// 指定图表的配置项和数据
								var option1 = {
									  series: [
										{
										  name: 'hs code 分类占比',
										  type: 'pie',
										  radius: '95%',
										  data: x1
										}
									  ]
								};

								// 使用刚指定的配置项和数据显示图表。
								hsChart.setOption(option1);
							}
								
						  that.loading = false;	 				  
						  }
					  });
		    },
			
			login()
			{
			  this.$router.push({
					path: '/login',
					params: {
					  sometext: ''
					}
				  }); 
			},

			back()
			{ 
			  this.$router.push({
					path: '/home/index',
					params: {
					  sometext: ''
					}
				  });  
			},
 

		},
        mounted() {
            console.log('name:' + this.$route.query.region);	 
            this.page = 1;
            this.size = 10;			
		    this.company_name = this.$route.query.companyName;//localStorage.getItem('companyName') ;
			this.company_address = this.$route.query.companyAddress ;//localStorage.getItem('companyAddress') ;
			this.company_type = this.$route.query.companyType;//localStorage.getItem('companyType') ;
			this.region = this.$route.query.region;  
			
			
			let that = this;
            this.getInfo();

		
			
			 
           },		   
		
    } ;

 
	 
</script>
 


// WEBPACK FOOTER //
// src/components/customs/customsReport.vue